import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=f0d67d6e"
import script from "./Consents.vue?vue&type=script&lang=js"
export * from "./Consents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports